import ru from '../../assets/locales/ru.json';
import en from '../../assets/locales/en.json';
import de from '../../assets/locales/de.json';
import fr from '../../assets/locales/fr.json';
import es from '../../assets/locales/es.json';
import it from '../../assets/locales/it.json';
import { Language, LanguageCode, TranslationResources } from '../types/LanguageType';

export const translations: TranslationResources = {
  ru,
  en,
  de,
  fr,
  es,
  it,
};

export const availableLanguages: Language[] = [
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: 'UK',
  },
  {
    code: 'de',
    name: 'German',
    nativeName: 'Deutsch',
    flag: 'DE',
  },
  {
    code: 'fr',
    name: 'French',
    nativeName: 'Français',
    flag: 'FR',
  },
  {
    code: 'es',
    name: 'Spanish',
    nativeName: 'Español',
    flag: 'ES',
  },
  {
    code: 'it',
    name: 'Italian',
    nativeName: 'Italiano',
    flag: 'IT',
  },
  {
    code: 'ru',
    name: 'Russian',
    nativeName: 'Русский',
    flag: 'RU',
  },
];

export const defaultLanguage: LanguageCode = 'en';

const INTL_LOCALES: Record<LanguageCode, string> = {
  ru: 'ru-RU',
  en: 'en-US',
  de: 'de-DE',
  fr: 'fr-FR',
  es: 'es-ES',
  it: 'it-IT',
};

export const getLanguageByCode = (code: LanguageCode | string): Language => {
  return (
    availableLanguages.find((lang) => lang.code === code)
    ?? availableLanguages.find((lang) => lang.code === defaultLanguage)!
  );
};

export const getIntlLocale = (code: LanguageCode | string): string => {
  if (code in INTL_LOCALES) {
    return INTL_LOCALES[code as LanguageCode];
  }

  return INTL_LOCALES[defaultLanguage];
};

export const getBrowserLanguage = (): LanguageCode => {
  if (typeof window === 'undefined') return defaultLanguage;

  const browserLang = navigator.language;
  const primaryLang = browserLang.split('-')[0];

  if (availableLanguages.some((lang) => lang.code === primaryLang)) {
    return primaryLang as LanguageCode;
  }

  return defaultLanguage;
};
